import { ContentFeedForHealthNewsCardProps } from '@ahc-digital/component-library';
import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C21ContentFeedForHealthNewsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
  PlaceholderImage?: ImageField;
};

export type C21ContentFeedForHealthNewsParams = {
  BackgroundColor?: string;
  HeadlineTag?: string;
  ContentAlignment?: string;
  HideImagesOnMobile?: string;
  EnableCarouselOnMobile?: string;
  HideSupportCopyOnCards?: string;
  APISlug?: string;
  NumberOfResults?: string;
  SlideTimingInSeconds?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;

export type ServerSideProps = {
  cards?: ContentFeedForHealthNewsCardProps[];
};

export type C21ContentFeedForHealthNewsProps = RenderingProps<
  C21ContentFeedForHealthNewsFields,
  C21ContentFeedForHealthNewsParams
> &
  ServerSideProps;
